module.exports = __webpack_public_path__ + "snigh-2f2fc432dd62c5a5a49e.jpg";